import { useState } from 'react';
import { OrganisationFormData } from '../../types/organization';
import { organizationEndpoints } from '../../services/api/endpoints/organisation.endpoint';

const initialFormData: OrganisationFormData = {
  companyName: '',
  client: {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    role: 'client_admin',
  },
  company: {
    name: '',
    description: '',
    website: '',
    phone: '',
    address: '',
    city: '',
    state: '',
    postcode: '',
    country: '',
    timezone: 'Australia/Sydney',
  },
  planType: 'standard',
  isBookingEnabled: true,
  resourceProfessional: '',
  bookingDescription: '',
  isVerifyBySMS: false,
  dealerPromo: '',
};

export const useOrganizationForm = () => {
  const [formData, setFormData] = useState<OrganisationFormData>(initialFormData);
  const [isLoading, setIsLoading] = useState(false);

  const updateFormData = (field: string, value: any) => {
    setFormData(prev => {
      const newData = { ...prev, [field]: value };

      // Keep clientEmail and companyName in sync
      if (field === 'client') {
        newData.client.email = value.email;
      }
      if (field === 'company') {
        newData.companyName = value.name;
      }

      return newData;
    });
  };

  const handleSubmit = async () => {
    try {
      const createdOrg = await organizationEndpoints.createOrganisation(formData);
      return createdOrg;
    } catch (err) {
      console.error('Error:', err);
    }
  };

  return {
    formData,
    updateFormData,
    handleSubmit,
    isLoading,
  };
};
